export default __webpack_public_path__ + "static/media/teladoc-banner.350b6a79.svg";